var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-content-metrics-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var task = ref.task;
    var content = ref.content;
    var isLoading = ref.isLoading;
    var isSubmitting = ref.isSubmitting;
    var errors = ref.errors;
    var errorMessage = ref.errorMessage;
    var uploadScreenshotUrl = ref.uploadScreenshotUrl;
    var handleFileChange = ref.handleFileChange;
    var handleResetUploads = ref.handleResetUploads;
    var uploadHeaders = ref.uploadHeaders;
    var uploadedFiles = ref.uploadedFiles;
    var isFileUploading = ref.isFileUploading;
    var isFileDeleting = ref.isFileDeleting;
    var back = ref.back;
    var updateContentMetrics = ref.updateContentMetrics;
    var handleScreenshotsSubmitted = ref.handleScreenshotsSubmitted;
    var handleFileDeleted = ref.handleFileDeleted;
    var handleBeforeUploadValidation = ref.handleBeforeUploadValidation;
return [_c('activation-content-metrics-view',{attrs:{"brief":brief,"task":task,"content":content,"is-loading":isLoading,"is-submitting":isSubmitting,"errors":errors,"error-message":errorMessage,"upload-screenshot-url":uploadScreenshotUrl,"handle-file-change":handleFileChange,"upload-headers":uploadHeaders,"uploaded-files":uploadedFiles,"is-file-uploading":isFileUploading,"is-file-deleting":isFileDeleting,"handle-before-upload-validation":handleBeforeUploadValidation},on:{"file-change":handleFileChange,"reset-uploads":handleResetUploads,"back":back,"update-content-metrics":updateContentMetrics,"screenshots-submitted":handleScreenshotsSubmitted,"file-deleted":handleFileDeleted}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }